/**************************************************
 * Nombre:       Formulario_Catalogo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {BookmarkOutlined, CategoryOutlined, Flag, FlagOutlined, PetsOutlined} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSPRODUCTO} from "../../../Constantes";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../Servicios/BD/obtenerCol";
import IngresoSelectPropId from "../../../Modulo_formularios/Componentes/IngresoSelectPropId";
import IngresoSelectFalsoVerdadero from "../../../Modulo_formularios/Componentes/IngresoSelectFalsoVerdadero";
import IngresoFecha from "../../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoSelectTextoArray from "../../../Modulo_formularios/Componentes/IngresoSelectTextoArray";

const Formulario_Catalogo = ({...props}) => {
    const [categorias, setCategorias] = useState([]);
    const [tipos, setTipos] = useState([]);

    useEffect(() => {
        obtenerCol('categorias').then(dox => {
            setCategorias(dox.data)
        })

        obtenerCol('tipos').then(dox => {
            if (dox.res) {
                setTipos(dox.data.map((it) => it.nombre))
            }

        })

    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelectPropId Icono={CategoryOutlined} nombre={'Categoria'} datoId={'prioridad'}
                                         propiedadId={'prioridad'} dato={'categoria'} {...props}
                                         requerido={'Campo requerido'}
                                         opciones={categorias}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoSelectTextoArray Icono={PetsOutlined} nombre={'Tipo Mascota'} dato={'tipos'} {...props}
                                             requerido={'Campo requerido'}
                                             opciones={tipos}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={BookmarkOutlined} nombre={'Marca'} dato={'marca'} {...props}
                                  opciones={tipos}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Nombre del producto'}
                                  dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Descripcion'} dato={'descripcion'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Extras</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoSelectFalsoVerdadero Icono={FlagOutlined} nombre={'Mas Vendidos'}
                                                 dato={'masVendido'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelectFalsoVerdadero Icono={FlagOutlined} nombre={'Oferta Tiempo Limitado'}
                                                 dato={'oferta'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoFecha Icono={FlagOutlined} nombre={'Fecha Oferta'} dato={'fechaOferta'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 12}}>**La imagen del producto en Oferta debe ser fondo
                        transparente</Typography>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Catalogo